const CART_KEY = 'cart';

const compactOrderItem = (item) => {
  // These fields belong to the catalog/card view. Keep all pricing snapshots,
  // barcodes, task metadata and user-entered fields needed by offline orders.
  const { description, deliveryHistory, deliveryHistoryCustomerId, selected, virtualIndex, ...orderItem } = item;
  return orderItem;
};

export const readStoredCart = (storage = window.localStorage) => {
  try {
    const cart = JSON.parse(storage.getItem(CART_KEY) || '[]');
    return Array.isArray(cart) ? cart : [];
  } catch (_) {
    return [];
  }
};

export const persistCartChange = (
  previous,
  next,
  storage = window.localStorage,
  { compact = false } = {},
) => {
  if (next === previous) return;
  const snapshot = compact ? next.map(compactOrderItem) : next;
  // One synchronous atomic write: no delayed final quantity or journal recovery.
  storage.setItem(CART_KEY, JSON.stringify(snapshot));
};
